import { Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { ItemOf } from '@vy/utils';
import { useDialog } from '../../../../../hooks/use-dialog';
import { InvoiceActivityDrawer } from './invoice-activity-components/InvoiceActivityDrawer';
import { InvoiceActivityHeader } from './invoice-activity-components/InvoiceActivityHeader';
import { InvoiceActivitySummary } from './invoice-activity-components/InvoiceActivitySummary';
import { InvoiceActivityTabs } from './invoice-activity-components/InvoiceActivityTabs/InvoiceActivityTabs';
import { GetLightInvoicesResponse } from '@vy/api-definition';
import { SystemEvent } from '@vy/types';

type InvoiceActivityProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  systemEvents: SystemEvent[];
};

export const InvoiceActivity: React.FC<InvoiceActivityProps> = ({ invoice, systemEvents }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <Button variant="text" size="small" startIcon={<VyIcon icon="InvoiceActivity" />} onClick={handleOpen}>
        Invoice activity
      </Button>

      <InvoiceActivityDrawer isDialogOpen={isDialogOpen} handleClose={handleClose}>
        <InvoiceActivityHeader invoice={invoice} handleClose={handleClose} />

        <InvoiceActivitySummary invoice={invoice} />

        <InvoiceActivityTabs invoice={invoice} systemEvents={systemEvents ?? []} />
      </InvoiceActivityDrawer>
    </>
  );
};
